var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCsLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "transparent",
      display: "block"
    },
    width: "120px",
    height: "120px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ldio-r9gxp5fdfc-cp",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.3,58.7H18.7c-4.8,0-8.7-3.9-8.7-8.7v0c0-4.8,3.9-8.7,8.7-8.7h62.7c4.8,0,8.7,3.9,8.7,8.7v0C90,54.8,86.1,58.7,81.3,58.7z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6362e7",
    strokeWidth: 2.7928,
    d: "M82 63H18c-7.2,0-13-5.8-13-13v0c0-7.2,5.8-13,13-13h64c7.2,0,13,5.8,13,13v0C95,57.2,89.2,63,82,63z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ldio-r9gxp5fdfc-cp)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: 0,
    width: 25,
    height: 100,
    fill: "#fcbc05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -75,
    y: 0,
    width: 25,
    height: 100,
    fill: "#070721"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -50,
    y: 0,
    width: 25,
    height: 100,
    fill: "#6362e7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: 0,
    width: 25,
    height: 100,
    fill: "#fcbc05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 25,
    height: 100,
    fill: "#fcbc05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 0,
    width: 25,
    height: 100,
    fill: "#070721"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 0,
    width: 25,
    height: 100,
    fill: "#6362e7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 0,
    width: 25,
    height: 100,
    fill: "#fcbc05"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    dur: "1s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0;100"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsLoading);
export default __webpack_public_path__ + "static/media/cs-loading.27be190960db653cd31034dea0752a9c.svg";
export { ForwardRef as ReactComponent };